export default __webpack_public_path__ + "static/media/boshidun.5b3835fd.jpg";